exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-container[data-v-6b5a475a]{padding:0 5px}.info-container .info[data-v-6b5a475a]{color:#f56c6c;font-weight:bold}", ""]);

// exports
